import { render } from "./TaxManagementView.vue?vue&type=template&id=019d3bc5"
import script from "./TaxManagementView.vue?vue&type=script&lang=js"
export * from "./TaxManagementView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__